import { Home, ClipboardList, Calendar, Users, MoreHorizontal } from "lucide-react";

const ITEMS = [
    { key: "hjem", label: "Hjem", icon: Home },
    { key: "opgaver", label: "Opgaver", icon: ClipboardList },
    { key: "kalender", label: "Kalender", icon: Calendar },
    { key: "team", label: "Team", icon: Users },
    { key: "mere", label: "Mere", icon: MoreHorizontal },
];

// Fixed bottom navigation. Active item: blue icon + blue text on a light-blue
// rounded background. Materialer & Indstillinger live under "Mere", which stays
// active on both sub-pages (handled by the caller via the `active` prop).
export default function EmployeeBottomNav({ active, onNavigate }) {
    return (
        <nav className="shrink-0 bg-white border-t border-slate-200 px-2 pt-1.5 pb-2" data-testid="employee-bottom-nav">
            <div className="max-w-md mx-auto grid grid-cols-5 gap-1">
                {ITEMS.map(({ key, label, icon: Icon }) => {
                    const on = active === key;
                    return (
                        <button
                            key={key}
                            type="button"
                            onClick={() => onNavigate(key)}
                            data-testid={`nav-${key}`}
                            aria-current={on ? "page" : undefined}
                            className="flex flex-col items-center justify-center gap-1 py-1 rounded-xl transition-transform active:scale-95"
                        >
                            <span className={`flex items-center justify-center w-14 h-7 rounded-full transition-colors ${on ? "bg-blue-50" : "bg-transparent"}`}>
                                <Icon className={`w-5 h-5 transition-colors ${on ? "text-blue-600" : "text-slate-400"}`} strokeWidth={on ? 2.4 : 2} />
                            </span>
                            <span className={`text-[11px] font-semibold transition-colors ${on ? "text-blue-600" : "text-slate-400"}`}>{label}</span>
                        </button>
                    );
                })}
            </div>
        </nav>
    );
}
